// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__9MWii","footerContent":"Footer_footerContent__UQfkx","footerLink":"Footer_footerLink__Ue+Ko","divider":"Footer_divider__fKEhQ"};